import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({ key: 'Umbre' });

const state = {
  sessionId: atom({
    key: 'sessionId',
    default: null,
    effects_UNSTABLE: [persistAtom],
  }),
  currentUser: atom({
    key: 'currentUser',
    default: {},
    effects_UNSTABLE: [persistAtom],
  }),
};

export default state;
